import { inject, Injectable } from "@angular/core";
import { from, Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { GoogleMapsLoaderService } from "./maps-api-loader.service";

@Injectable()
export class GeocodeService {
    private _mapsLoader = inject(GoogleMapsLoaderService);

    private geocoder: any;

    constructor() {}

    public waitForMapsToLoad(): Observable<boolean> {
        if (!this.geocoder) {
            return from(this._mapsLoader.load()).pipe(
                switchMap(() => {
                    this.geocoder = new google.maps.Geocoder();
                    return [true];
                })
            );
        }
        return from([true]);
    }

    geocodeAddress(address: string): Observable<GeocodeLocation> {
        return this.waitForMapsToLoad().pipe(
            switchMap(() => {
                return new Observable<GeocodeLocation>((observer) => {
                    this.geocoder.geocode({ address: address }, (results, status) => {
                        if (status === google.maps.GeocoderStatus.OK) {
                            observer.next({
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng(),
                                found: true,
                            });
                        } else {
                            observer.next({ lat: -15.793889, lng: -47.882778, found: false });
                        }
                        observer.complete();
                    });
                });
            })
        );
    }
}

export interface GeocodeLocation {
    lat: number;
    lng: number;
    found?: boolean;
}
